import React, { FC, useState } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Link, Stack, TextField } from '@mui/material';

import { AtsType } from 'src/generated/mloop-graphql';

import HelpCenterUrl from 'src/constants/HelpCenterUrl';

import { useGemIntegrationPut } from 'src/hooks/api/integration';
import { getAtsService } from 'src/hooks/atsService';

export interface Props {
  onClose: () => void;
  apiKey: string;
  disabled?: boolean;
  onSave: () => void;
}

const GemDialog: FC<Props> = ({ onClose, apiKey, disabled = false, onSave }) => {
  const { t } = useTranslation();
  const [apiKeyVal, setAPIKeyVal] = useState<string>(apiKey);
  const putGem = useGemIntegrationPut();

  const atsService = getAtsService(AtsType.Gem);

  return (
    <Dialog
      maxWidth="md"
      open
      onClose={onClose}
      title={t('hiring-dashboard-settings-integrations:settings.integrations.dialogTitle.gem')}
      submitOptions={{
        isDisabled: disabled || !apiKeyVal,
        onClick: () => {
          putGem.mutate(
            {
              apiKey: apiKeyVal,
            },
            {
              onSuccess: onSave,
            }
          );
        },
        label: t('hiring-dashboard-common:common.save'),
      }}
      cancelOptions={{
        label: t('hiring-dashboard-common:common.cancel'),
        onClick: onClose,
      }}
      decoration={
        <img
          style={{ borderRadius: '6px' }}
          height="64px"
          width="64px"
          alt={t('hiring-dashboard-settings-integrations:settings.integrations.apiKeyDialog.logoAlt')}
          src={atsService.logoUrl}
        />
      }
    >
      <Stack spacing={1}>
        <TextField
          disabled={disabled}
          fullWidth
          id="outlined-basic"
          label={t('hiring-dashboard-settings-integrations:settings.integrations.apiKeyDialog.apiKeyLabel')}
          variant="outlined"
          defaultValue={apiKeyVal}
          onChange={(event) => setAPIKeyVal(event.target.value)}
          helperText={t('hiring-dashboard-settings-integrations:settings.integrations.gemDialog.helperText')}
        />
        <Link target="_blank" rel="noopener noreferrer" href={HelpCenterUrl.GEM_INTEGRATION} color="info">
          {t('hiring-dashboard-settings-integrations:settings.integrations.gemDialog.learnMore')}
        </Link>
      </Stack>
    </Dialog>
  );
};

export default GemDialog;
